import { render, staticRenderFns } from "./StudentAtGlanceReport.vue?vue&type=template&id=c1c4773a&scoped=true&"
import script from "./StudentAtGlanceReport.vue?vue&type=script&lang=js&"
export * from "./StudentAtGlanceReport.vue?vue&type=script&lang=js&"
import style0 from "./StudentAtGlanceReport.vue?vue&type=style&index=0&id=c1c4773a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c4773a",
  null
  
)

export default component.exports